

















export default {
    props: {
        title: { type: String, default: 'warning icon' },
		fill: { type: String, default: 'currentColor' },
		secondaryfill: { type: String, default: '' }
    }
}
